import { LayoutHeader } from "@/Header";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/business/layout/user-customer-info")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <LayoutHeader title={"고객 상세 정보"} hasBackBtn hasFootPrint={false} />
  );
}
